//before 20-5-2026

// import React, { useEffect, useState } from 'react';
// import { Container, Row, Col, Form, Button } from 'react-bootstrap';
// import {
//   FaBuilding,
//   FaPhone,
//   FaEnvelope,
//   FaGlobe,
//   FaMapMarkerAlt,
//   FaFacebook,
//   FaLinkedin,
//   FaTwitter,
//   FaInstagram,
//   FaYoutube,
//   FaFileInvoice,
//   FaIdCard,
// } from 'react-icons/fa';
// import { SiTiktok } from 'react-icons/si';
// import { useDispatch, useSelector } from 'react-redux';
// import { Notify } from '../Utility/Notify';
// import AddIcon from '@mui/icons-material/Add';
// import {
//   Get_All_Company_Profile,
//   UpdateCompanyProfileData,
// } from '../Redux/Actions/Company_Profile_Action';
// import { Link, useParams } from 'react-router-dom';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { useTheme } from '@mui/material';

// export const EditCompanyProfilePage = () => {
//   const { id } = useParams();
//   const dispatch = useDispatch();

//   useEffect(() => {
//     const fetchData = async () => {
//       await dispatch(Get_All_Company_Profile());
//     };
//     fetchData();
//   }, []);

//   const resgetall = useSelector((state) => state.AllCompanyProfile.CompanyProfile);
//   let AllCompanyprofile = Array.isArray(resgetall?.data) ? resgetall.data : [];

//   // --- logo preview
//   const [logoPreview, setLogoPreview] = useState(null);
//   const [logo, setLogo] = useState(null);

//   // --- data fields
//   const [companyName, setCompanyName] = useState('');
//   const [description, setDescription] = useState('');
//   const [primaryPhone, setPrimaryPhone] = useState('');
//   const [secondaryPhone, setSecondaryPhone] = useState('');
//   const [email, setEmail] = useState('');
//   const [address, setAddress] = useState('');
//   const [website, setWebsite] = useState('');
//   const [facebook, setFacebook] = useState('');
//   const [twitter, setTwitter] = useState('');
//   const [instagram, setInstagram] = useState('');
//   const [linkedin, setLinkedin] = useState('');
//   const [youtube, setYoutube] = useState('');
//   const [tiktok, setTiktok] = useState('');
//   const [snapchat, setSnapchat] = useState('');
//   const [taxId, setTaxId] = useState('');
//   const [commercialRegNo, setCommercialRegNo] = useState('');
//   const [loading, setloading] = useState(true);

//   // --- logo preview handler
//   const handleLogoChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setLogoPreview(URL.createObjectURL(file));
//       setLogo(file);
//     }
//   };

//   // --- fill data from existing profile (edit mode)
//   useEffect(() => {
//     if (AllCompanyprofile.length > 0) {
//       const profile = AllCompanyprofile[0]; // Assuming one profile only
//       setCompanyName(profile.companyName || '');
//       setDescription(profile.description || '');
//       setPrimaryPhone(profile.primaryPhone || '');
//       setSecondaryPhone(profile.secondaryPhone || '');
//       setEmail(profile.email || '');
//       setAddress(profile.address || '');
//       setWebsite(profile.website || '');
//       setFacebook(profile.facebook || '');
//       setTwitter(profile.twitter || '');
//       setInstagram(profile.instagram || '');
//       setLinkedin(profile.linkedin || '');
//       setYoutube(profile.youtube || '');
//       setTiktok(profile.tiktok || '');
//       setSnapchat(profile.snapchat || '');
//       setTaxId(profile.taxId || '');
//       setCommercialRegNo(profile.commercialRegNo || '');
//       if (profile.logo) {
//         setLogoPreview(profile.logo); // Assuming logo is a URL or base64 string
//       }
//     }
//   }, [AllCompanyprofile]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (
//       !companyName.trim() ||
//       !description.trim() ||
//       !primaryPhone.trim() ||
//       !email.trim() ||
//       !address.trim() ||
//       !logoPreview
//     ) {
//       Notify(
//         'error',
//         'Please fill in all the required fields (Name, Logo, Description, Primary Phone, Email, and Address)',
//         'error',
//       );
//       return;
//     }

//     const formData = new FormData();
//     // if (logo) formData.append('logo', logo);
//     formData.append('companyName', companyName);
//     formData.append('description', description);
//     formData.append('primaryPhone', primaryPhone);
//     formData.append('secondaryPhone', secondaryPhone);
//     formData.append('email', email);
//     formData.append('address', address);
//     formData.append('website', website);
//     formData.append('facebook', facebook);
//     formData.append('twitter', twitter);
//     formData.append('instagram', instagram);
//     formData.append('linkedin', linkedin);
//     formData.append('youtube', youtube);
//     formData.append('tiktok', tiktok);
//     formData.append('snapchat', snapchat);
//     formData.append('taxId', taxId);
//     formData.append('commercialRegNo', commercialRegNo);

//     setloading(true);
//     await dispatch(UpdateCompanyProfileData(id, formData));
//     setloading(false);
//   };

//   const resadd = useSelector((state) => state.AllCompanyProfile.CompanyProfileupdate);

//   useEffect(() => {
//     if (loading === false && resadd && resadd.data) {
//       Notify('success', 'Data Updated successfully', 'success');
//       //   setCompanyName('');
//       //   setDescription('');
//       //   setPrimaryPhone('');
//       //   setSecondaryPhone('');
//       //   setEmail('');
//       //   setAddress('');
//       //   setWebsite('');
//       //   setFacebook('');
//       //   setTwitter('');
//       //   setInstagram('');
//       //   setLinkedin('');
//       //   setYoutube('');
//       //   setTiktok('');
//       //   setSnapchat('');
//       //   setTaxId('');
//       //   setCommercialRegNo('');
//       //   setLogo(null);
//       //   setLogoPreview(null);
//     }
//   }, [loading]);

//   const theme = useTheme();
//   const mode = theme.palette.mode;

//   return (
//     <Container className=" startpage">
//       <div className="">
//         <Link to="/AllLeadsForAdmin" style={{ color: '#0F7687', textDecoration: 'none' }}>
//           Home
//         </Link>
//         <KeyboardDoubleArrowRightIcon />
//         <Link
//           to="/CompanyProfile"
//           style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687', textDecoration: 'none' }}
//         >
//           Company Profile
//         </Link>
//         <KeyboardDoubleArrowRightIcon />
//         <span>Edit Company Profile</span>
//       </div>

//       <h2 className="mb-4 text-center">Edit Company Profile</h2>
//       <div className="p-4 shadow">
//         <Form onSubmit={handleSubmit}>
//           <Row className="mb-3">
//             <Col md={4} className="text-center mb-3">
//               {logoPreview ? (
//                 <img
//                   src={logoPreview}
//                   alt="Company Logo"
//                   className="img-fluid rounded"
//                   style={{ maxHeight: '200px' }}
//                 />
//               ) : (
//                 <div className="border p-4 rounded bg-light">No logo selected</div>
//               )}
//               <Form.Group controlId="formFile" className="mt-3">
//                 <Form.Label>
//                   <strong>Upload Company Logo</strong>
//                 </Form.Label>
//                 <Form.Control type="file" onChange={handleLogoChange} />
//               </Form.Group>
//             </Col>

//             <Col md={8}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   <FaBuilding /> Company Name
//                 </Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={companyName}
//                   onChange={(e) => setCompanyName(e.target.value)}
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>📝 Short Description</Form.Label>
//                 <Form.Control
//                   as="textarea"
//                   rows={3}
//                   value={description}
//                   onChange={(e) => setDescription(e.target.value)}
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   <FaPhone /> Primary Phone
//                 </Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={primaryPhone}
//                   onChange={(e) => setPrimaryPhone(e.target.value)}
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   <FaPhone /> Secondary Phone (Optional)
//                 </Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={secondaryPhone}
//                   onChange={(e) => setSecondaryPhone(e.target.value)}
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   <FaEnvelope /> Company Email
//                 </Form.Label>
//                 <Form.Control
//                   type="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   <FaMapMarkerAlt /> Full Address
//                 </Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={address}
//                   onChange={(e) => setAddress(e.target.value)}
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   <FaGlobe /> Website URL
//                 </Form.Label>
//                 <Form.Control
//                   type="url"
//                   value={website}
//                   onChange={(e) => setWebsite(e.target.value)}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <h5 className="mt-4 mb-3">Social Media</h5>
//           <Row>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   <FaFacebook /> Facebook
//                 </Form.Label>
//                 <Form.Control
//                   type="url"
//                   value={facebook}
//                   onChange={(e) => setFacebook(e.target.value)}
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   <FaTwitter /> Twitter
//                 </Form.Label>
//                 <Form.Control
//                   type="url"
//                   value={twitter}
//                   onChange={(e) => setTwitter(e.target.value)}
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   <FaInstagram /> Instagram
//                 </Form.Label>
//                 <Form.Control
//                   type="url"
//                   value={instagram}
//                   onChange={(e) => setInstagram(e.target.value)}
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   <SiTiktok /> TikTok
//                 </Form.Label>
//                 <Form.Control
//                   type="url"
//                   value={tiktok}
//                   onChange={(e) => setTiktok(e.target.value)}
//                 />
//               </Form.Group>
//             </Col>

//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   <FaLinkedin /> LinkedIn
//                 </Form.Label>
//                 <Form.Control
//                   type="url"
//                   value={linkedin}
//                   onChange={(e) => setLinkedin(e.target.value)}
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   <FaYoutube /> YouTube
//                 </Form.Label>
//                 <Form.Control
//                   type="url"
//                   value={youtube}
//                   onChange={(e) => setYoutube(e.target.value)}
//                 />
//               </Form.Group>

//               <Form.Group className="mb-3">
//                 <Form.Label>👻 Snapchat</Form.Label>
//                 <Form.Control
//                   type="url"
//                   value={snapchat}
//                   onChange={(e) => setSnapchat(e.target.value)}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <h5 className="mt-4 mb-3">Administrative Info</h5>
//           <Row>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   <FaFileInvoice /> Tax ID
//                 </Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={taxId}
//                   onChange={(e) => setTaxId(e.target.value)}
//                 />
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>
//                   <FaIdCard /> Commercial Registration No.
//                 </Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={commercialRegNo}
//                   onChange={(e) => setCommercialRegNo(e.target.value)}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <Row className="mt-4 justify-content-center">
//             <Col xs={12} sm={6} md={4} className="mb-2 text-center">
//               {
//                 <Button variant="primary" type="submit" className="w-100">
//                   Confirm Edit Company Profile <AddIcon />
//                 </Button>
//               }
//             </Col>
//           </Row>
//         </Form>
//       </div>
//       <div style={{ marginTop: '100px' }}></div>
//     </Container>
//   );
// };





























// 20-5-2026

import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import {
  FaBuilding,
  FaPhone,
  FaEnvelope,
  FaGlobe,
  FaMapMarkerAlt,
  FaFacebook,
  FaLinkedin,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaFileInvoice,
  FaIdCard,
  FaRedditAlien,
} from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';
import { useSidebarWidth } from '../Utility/useSidebarWidth';
import { Notify } from '../Utility/Notify';
import {
  Get_All_Company_Profile,
  UpdateCompanyProfileData,
} from '../Redux/Actions/Company_Profile_Action';

export const EditCompanyProfilePage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const sidebarWidth = useSidebarWidth();

  const [logoPreview, setLogoPreview] = useState(null);
  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [formErrors, setFormErrors] = useState({});

  const [companyName, setCompanyName]       = useState('');
  const [description, setDescription]       = useState('');
  const [primaryPhone, setPrimaryPhone]     = useState('');
  const [secondaryPhone, setSecondaryPhone] = useState('');
  const [email, setEmail]                   = useState('');
  const [address, setAddress]               = useState('');
  const [website, setWebsite]               = useState('');
  const [facebook, setFacebook]             = useState('');
  const [twitter, setTwitter]               = useState('');
  const [instagram, setInstagram]           = useState('');
  const [linkedin, setLinkedin]             = useState('');
  const [youtube, setYoutube]               = useState('');
  const [tiktok, setTiktok]                 = useState('');
  const [snapchat, setSnapchat]             = useState('');
  const [taxId, setTaxId]                   = useState('');
  const [commercialRegNo, setCommercialRegNo] = useState('');

  /* ── Fetch ── */
  useEffect(() => {
    const fetchData = async () => {
      setInitialLoading(true);
      await dispatch(Get_All_Company_Profile());
      setInitialLoading(false);
    };
    fetchData();
  }, [dispatch]);

  const resgetall = useSelector((state) => state.AllCompanyProfile.CompanyProfile);
  let AllCompanyprofile = Array.isArray(resgetall?.data) ? resgetall.data : [];

  /* ── Fill fields from existing profile ── */
  useEffect(() => {
    if (AllCompanyprofile.length > 0) {
      const p = AllCompanyprofile[0];
      setCompanyName(p.companyName || '');
      setDescription(p.description || '');
      setPrimaryPhone(p.primaryPhone || '');
      setSecondaryPhone(p.secondaryPhone || '');
      setEmail(p.email || '');
      setAddress(p.address || '');
      setWebsite(p.website || '');
      setFacebook(p.facebook || '');
      setTwitter(p.twitter || '');
      setInstagram(p.instagram || '');
      setLinkedin(p.linkedin || '');
      setYoutube(p.youtube || '');
      setTiktok(p.tiktok || '');
      setSnapchat(p.snapchat || '');
      setTaxId(p.taxId || '');
      setCommercialRegNo(p.commercialRegNo || '');
      if (p.logo) setLogoPreview(p.logo);
    }
  }, [AllCompanyprofile]);

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoPreview(URL.createObjectURL(file));
      setLogo(file);
      if (formErrors.logo) setFormErrors(p => ({ ...p, logo: '' }));
    }
  };

  /* ── Validate ── */
  const validate = () => {
    const errors = {};
    if (!companyName.trim()) errors.companyName = 'Company name is required';
    if (!description.trim()) errors.description = 'Description is required';
    if (!primaryPhone.trim()) errors.primaryPhone = 'Primary phone is required';
    if (!email.trim() || !email.match(/^\S+@\S+\.\S+$/)) errors.email = 'Valid email is required';
    if (!address.trim()) errors.address = 'Address is required';
    if (!logoPreview) errors.logo = 'Company logo is required';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  /* ── Submit ── */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return Notify('error', 'Please fix form errors', 'error');

    const formData = new FormData();
    if (logo) formData.append('logo', logo);
    formData.append('companyName', companyName);
    formData.append('description', description);
    formData.append('primaryPhone', primaryPhone);
    formData.append('secondaryPhone', secondaryPhone);
    formData.append('email', email);
    formData.append('address', address);
    formData.append('website', website);
    formData.append('facebook', facebook);
    formData.append('twitter', twitter);
    formData.append('instagram', instagram);
    formData.append('linkedin', linkedin);
    formData.append('youtube', youtube);
    formData.append('tiktok', tiktok);
    formData.append('snapchat', snapchat);
    formData.append('taxId', taxId);
    formData.append('commercialRegNo', commercialRegNo);

    setLoading(true);
    await dispatch(UpdateCompanyProfileData(id, formData));
    setLoading(false);
  };

  const resadd = useSelector((state) => state.AllCompanyProfile.CompanyProfileupdate);
  useEffect(() => {
    if (loading === false && resadd && resadd.data) {
      Notify('success', 'Company profile updated successfully', 'success');
    }
  }, [loading, resadd]);

  /* ── Shared style helpers ── */
  const inputStyle = (hasError) => ({
    width: '100%',
    padding: '12px 16px',
    borderRadius: '12px',
    border: `1.5px solid ${hasError ? '#ef4444' : (isDark ? '#2d3248' : '#e2e8f0')}`,
    backgroundColor: isDark ? '#151827' : '#ffffff',
    color: isDark ? '#f1f5f9' : '#0f172a',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.2s',
    fontFamily: "'DM Sans', sans-serif",
    boxSizing: 'border-box',
  });

  const textareaStyle = (hasError) => ({
    ...inputStyle(hasError),
    resize: 'vertical',
    minHeight: '80px',
  });

  const labelStyle = {
    display: 'block',
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: isDark ? '#9ca3af' : '#64748b',
    marginBottom: '8px',
  };

  const errorStyle = {
    fontSize: '12px',
    color: '#ef4444',
    margin: '5px 0 0',
  };

  const onFocus = (e) => {
    e.target.style.borderColor = '#2563eb';
    e.target.style.backgroundColor = isDark ? '#1a1f35' : '#ffffff';
    e.target.style.boxShadow = '0 0 0 3px rgba(37,99,235,0.12)';
  };

  const onBlur = (e, hasError) => {
    e.target.style.borderColor = hasError ? '#ef4444' : (isDark ? '#2d3248' : '#e2e8f0');
    e.target.style.backgroundColor = isDark ? '#151827' : '#ffffff';
    e.target.style.boxShadow = 'none';
  };

  const fieldWrap = { marginBottom: '24px' };

  const sectionTitle = {
    fontSize: '18px',
    fontWeight: 700,
    color: isDark ? '#f1f5f9' : '#0f172a',
    margin: '0 0 20px 0',
    paddingBottom: '12px',
    borderBottom: `2px solid ${isDark ? '#334155' : '#e2e8f0'}`,
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  };

  const twoColumns = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
  };

  /* ── Loading state ── */
  if (initialLoading) {
    return (
      <div style={{
        position: 'fixed',
        top: '50px',
        left: sidebarWidth,
        right: 0,
        bottom: 0,
        transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <CircularProgress size={48} style={{ color: isDark ? '#60a5fa' : '#2563eb' }} />
      </div>
    );
  }

  /* ── Render ── */
  return (
    <div style={{
      position: 'fixed',
      top: '50px',
      left: sidebarWidth,
      right: 0,
      bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      overflowX: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    }}>

      {/* ── Breadcrumb ── */}
      <section style={{ padding: '16px 20px 0', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}>
          <Link to="/AllLeadsForAdmin" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500, fontFamily: "'DM Sans',sans-serif" }}>
            Home
          </Link>
          <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
          <Link to="/CompanyProfile" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500, fontFamily: "'DM Sans',sans-serif" }}>
            Company Profile
          </Link>
          <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
          <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600, fontFamily: "'DM Sans',sans-serif" }}>
            Edit
          </span>
        </div>
      </section>

      {/* ── Main Content ── */}
      <section style={{ flex: 1, padding: '20px 20px 48px', display: 'flex', flexDirection: 'column' }}>

        {/* Page Header */}
        <div style={{ marginBottom: '20px' }}>
          <div style={{ fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: isDark ? '#6b7280' : '#94a3b8', marginBottom: '4px', fontFamily: "'DM Sans', sans-serif" }}>
            SETTINGS
          </div>
          <h1 style={{
            fontSize: '24px',
            fontWeight: 700,
            color: isDark ? '#f1f5f9' : '#0f172a',
            margin: '0 0 4px',
            letterSpacing: '-0.4px',
            fontFamily: "'DM Sans', sans-serif",
          }}>
            EDIT COMPANY PROFILE
          </h1>
          <p style={{ fontSize: '13px', color: isDark ? '#6b7280' : '#64748b', margin: 0, fontFamily: "'DM Sans', sans-serif" }}>
            Update your corporate identity within the EstateCore ecosystem.
          </p>
        </div>

        {/* Form Card */}
        <div style={{
          backgroundColor: isDark ? '#1e2132' : '#ffffff',
          borderRadius: '16px',
          padding: '32px 36px',
          boxShadow: isDark ? '0 8px 32px rgba(0,0,0,0.35)' : '0 2px 16px rgba(0,0,0,0.06)',
          border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
          width: '100%',
        }}>

          <form onSubmit={handleSubmit}>

            {/* ── Logo Upload ── */}
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '36px' }}>
              <div style={{ textAlign: 'center' }}>
                {logoPreview ? (
                  <img
                    src={logoPreview}
                    alt="Company Logo"
                    style={{
                      width: '110px',
                      height: '110px',
                      objectFit: 'cover',
                      borderRadius: '55px',
                      border: `3px solid ${isDark ? '#334155' : '#e2e8f0'}`,
                      padding: '4px',
                      backgroundColor: isDark ? '#151827' : '#f8fafc',
                    }}
                  />
                ) : (
                  <div style={{
                    width: '110px',
                    height: '110px',
                    borderRadius: '55px',
                    border: `2px dashed ${isDark ? '#334155' : '#cbd5e1'}`,
                    backgroundColor: isDark ? '#151827' : '#f8fafc',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: isDark ? '#64748b' : '#94a3b8',
                    fontSize: '12px',
                  }}>
                    Logo
                  </div>
                )}
                <div style={{ marginTop: '14px' }}>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleLogoChange}
                    style={{ display: 'none' }}
                    id="logo-upload-edit"
                  />
                  <button
                    type="button"
                    onClick={() => document.getElementById('logo-upload-edit').click()}
                    style={{
                      padding: '8px 20px',
                      borderRadius: '8px',
                      border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
                      backgroundColor: 'transparent',
                      color: isDark ? '#f1f5f9' : '#0f172a',
                      cursor: 'pointer',
                      fontSize: '13px',
                      fontWeight: 500,
                      fontFamily: "'DM Sans', sans-serif",
                    }}
                  >
                    Change Logo
                  </button>
                  {formErrors.logo && <p style={errorStyle}>{formErrors.logo}</p>}
                </div>
              </div>
            </div>

            {/* ── TWO-COLUMN: Basic Info (left) | Social Media (right) ── */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', alignItems: 'start' }}>

              {/* LEFT: Basic Information */}
              <div>
                <div style={sectionTitle}>
                  <FaBuilding size={18} />
                  Basic Information
                </div>

                <div style={fieldWrap}>
                  <label style={labelStyle}>COMPANY NAME</label>
                  <input
                    style={inputStyle(!!formErrors.companyName)}
                    value={companyName}
                    onChange={(e) => { setCompanyName(e.target.value); if (formErrors.companyName) setFormErrors(p => ({ ...p, companyName: '' })); }}
                    type="text"
                    placeholder="e.g., Azure Reality Group"
                    onFocus={onFocus}
                    onBlur={(e) => onBlur(e, !!formErrors.companyName)}
                  />
                  {formErrors.companyName && <p style={errorStyle}>{formErrors.companyName}</p>}
                </div>

                <div style={fieldWrap}>
                  <label style={labelStyle}>SHORT DESCRIPTION</label>
                  <textarea
                    rows={3}
                    style={textareaStyle(!!formErrors.description)}
                    value={description}
                    onChange={(e) => { setDescription(e.target.value); if (formErrors.description) setFormErrors(p => ({ ...p, description: '' })); }}
                    placeholder="Briefly describe your company's core values and specialization..."
                    onFocus={onFocus}
                    onBlur={(e) => onBlur(e, !!formErrors.description)}
                  />
                  {formErrors.description && <p style={errorStyle}>{formErrors.description}</p>}
                </div>

                <div style={twoColumns}>
                  <div style={fieldWrap}>
                    <label style={labelStyle}>PRIMARY PHONE</label>
                    <input
                      style={inputStyle(!!formErrors.primaryPhone)}
                      value={primaryPhone}
                      onChange={(e) => { setPrimaryPhone(e.target.value); if (formErrors.primaryPhone) setFormErrors(p => ({ ...p, primaryPhone: '' })); }}
                      type="text"
                      placeholder="+1 (555) 000-0000"
                      onFocus={onFocus}
                      onBlur={(e) => onBlur(e, !!formErrors.primaryPhone)}
                    />
                    {formErrors.primaryPhone && <p style={errorStyle}>{formErrors.primaryPhone}</p>}
                  </div>
                  <div style={fieldWrap}>
                    <label style={labelStyle}>SECONDARY PHONE</label>
                    <input
                      style={inputStyle(false)}
                      value={secondaryPhone}
                      onChange={(e) => setSecondaryPhone(e.target.value)}
                      type="text"
                      placeholder="+1 (555) 000-0000"
                      onFocus={onFocus}
                      onBlur={(e) => onBlur(e, false)}
                    />
                  </div>
                </div>

                <div style={twoColumns}>
                  <div style={fieldWrap}>
                    <label style={labelStyle}>COMPANY EMAIL</label>
                    <input
                      style={inputStyle(!!formErrors.email)}
                      value={email}
                      onChange={(e) => { setEmail(e.target.value); if (formErrors.email) setFormErrors(p => ({ ...p, email: '' })); }}
                      type="email"
                      placeholder="contact@company.com"
                      onFocus={onFocus}
                      onBlur={(e) => onBlur(e, !!formErrors.email)}
                    />
                    {formErrors.email && <p style={errorStyle}>{formErrors.email}</p>}
                  </div>
                  <div style={fieldWrap}>
                    <label style={labelStyle}>WEBSITE URL</label>
                    <input
                      style={inputStyle(false)}
                      value={website}
                      onChange={(e) => setWebsite(e.target.value)}
                      type="url"
                      placeholder="https://www.company.com"
                      onFocus={onFocus}
                      onBlur={(e) => onBlur(e, false)}
                    />
                  </div>
                </div>

                <div style={fieldWrap}>
                  <label style={labelStyle}>FULL ADDRESS</label>
                  <input
                    style={inputStyle(!!formErrors.address)}
                    value={address}
                    onChange={(e) => { setAddress(e.target.value); if (formErrors.address) setFormErrors(p => ({ ...p, address: '' })); }}
                    type="text"
                    placeholder="123 Executive Plaza, Financial District, New York"
                    onFocus={onFocus}
                    onBlur={(e) => onBlur(e, !!formErrors.address)}
                  />
                  {formErrors.address && <p style={errorStyle}>{formErrors.address}</p>}
                </div>
              </div>

              {/* RIGHT: Social Media */}
              <div>
                <div style={sectionTitle}>
                  <FaGlobe size={18} />
                  Social Media Presence
                </div>

                <div style={twoColumns}>
                  <div style={fieldWrap}>
                    <label style={labelStyle}><FaFacebook size={12} /> FACEBOOK</label>
                    <input style={inputStyle(false)} value={facebook} onChange={(e) => setFacebook(e.target.value)} type="url" placeholder="facebook.com/company" onFocus={onFocus} onBlur={(e) => onBlur(e, false)} />
                  </div>
                  <div style={fieldWrap}>
                    <label style={labelStyle}><FaInstagram size={12} /> INSTAGRAM</label>
                    <input style={inputStyle(false)} value={instagram} onChange={(e) => setInstagram(e.target.value)} type="url" placeholder="instagram.com/company" onFocus={onFocus} onBlur={(e) => onBlur(e, false)} />
                  </div>
                  <div style={fieldWrap}>
                    <label style={labelStyle}><FaTwitter size={12} /> TWITTER</label>
                    <input style={inputStyle(false)} value={twitter} onChange={(e) => setTwitter(e.target.value)} type="url" placeholder="twitter.com/company" onFocus={onFocus} onBlur={(e) => onBlur(e, false)} />
                  </div>
                  <div style={fieldWrap}>
                    <label style={labelStyle}><FaLinkedin size={12} /> LINKEDIN</label>
                    <input style={inputStyle(false)} value={linkedin} onChange={(e) => setLinkedin(e.target.value)} type="url" placeholder="linkedin.com/company" onFocus={onFocus} onBlur={(e) => onBlur(e, false)} />
                  </div>
                  <div style={fieldWrap}>
                    <label style={labelStyle}><FaYoutube size={12} /> YOUTUBE</label>
                    <input style={inputStyle(false)} value={youtube} onChange={(e) => setYoutube(e.target.value)} type="url" placeholder="youtube.com/company" onFocus={onFocus} onBlur={(e) => onBlur(e, false)} />
                  </div>
                  <div style={fieldWrap}>
                    <label style={labelStyle}><SiTiktok size={12} /> TIKTOK</label>
                    <input style={inputStyle(false)} value={tiktok} onChange={(e) => setTiktok(e.target.value)} type="url" placeholder="tiktok.com/@company" onFocus={onFocus} onBlur={(e) => onBlur(e, false)} />
                  </div>
                  <div style={fieldWrap}>
                    <label style={labelStyle}>👻 SNAPCHAT</label>
                    <input style={inputStyle(false)} value={snapchat} onChange={(e) => setSnapchat(e.target.value)} type="url" placeholder="snapchat.com/add/company" onFocus={onFocus} onBlur={(e) => onBlur(e, false)} />
                  </div>
                </div>
              </div>

            </div>
            {/* ── END TWO-COLUMN ── */}

            {/* ── Administrative Info (full width) ── */}
            <div style={{ marginTop: '40px', paddingTop: '32px', borderTop: `2px solid ${isDark ? '#334155' : '#e2e8f0'}` }}>
              <div style={{ ...sectionTitle, margin: '0 0 20px 0' }}>
                <FaFileInvoice size={18} />
                Administrative Info
              </div>
              <div style={twoColumns}>
                <div style={fieldWrap}>
                  <label style={labelStyle}>TAX ID / VAT NO.</label>
                  <input
                    style={inputStyle(false)}
                    value={taxId}
                    onChange={(e) => setTaxId(e.target.value)}
                    type="text"
                    placeholder="TX-8829-102"
                    onFocus={onFocus}
                    onBlur={(e) => onBlur(e, false)}
                  />
                </div>
                <div style={fieldWrap}>
                  <label style={labelStyle}>COMMERCIAL REGISTRATION NO.</label>
                  <input
                    style={inputStyle(false)}
                    value={commercialRegNo}
                    onChange={(e) => setCommercialRegNo(e.target.value)}
                    type="text"
                    placeholder="CRN: 2023-4567"
                    onFocus={onFocus}
                    onBlur={(e) => onBlur(e, false)}
                  />
                </div>
              </div>
            </div>

            {/* Footer Note */}
            <div style={{
              marginTop: '32px',
              padding: '16px',
              borderRadius: '12px',
              backgroundColor: isDark ? 'rgba(37,99,235,0.08)' : 'rgba(37,99,235,0.04)',
              border: `1px solid ${isDark ? 'rgba(37,99,235,0.2)' : 'rgba(37,99,235,0.15)'}`,
              textAlign: 'center',
            }}>
              <p style={{ fontSize: '12px', color: isDark ? '#93c5fd' : '#6b7280', margin: 0, fontFamily: "'DM Sans', sans-serif" }}>
                All information will be validated by the administrative board.
              </p>
            </div>

            {/* Divider */}
            <div style={{ height: '1px', backgroundColor: isDark ? '#2a2f45' : '#e8eaf0', margin: '32px 0 28px' }} />

            {/* Save Button */}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button
                type="submit"
                disabled={loading}
                style={{
                  padding: '14px 40px',
                  borderRadius: '10px',
                  border: 'none',
                  background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                  color: '#fff',
                  fontSize: '13px',
                  fontWeight: 700,
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  transition: 'all 0.2s',
                  boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                  fontFamily: "'DM Sans', sans-serif",
                  minWidth: '260px',
                }}
                onMouseEnter={(e) => { if (!loading) { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)'; } }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)'; }}
              >
                {loading ? (
                  <>
                    <CircularProgress size={16} style={{ color: '#fff' }} />
                    <span>Saving...</span>
                  </>
                ) : (
                  <>
                    <AddIcon sx={{ fontSize: 17 }} />
                    <span>Confirm Edit Company Profile</span>
                  </>
                )}
              </button>
            </div>

          </form>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        flexShrink: 0,
        padding: '14px 20px',
        borderTop: `1px solid ${isDark ? '#2a2f45' : '#e8eaf0'}`,
        fontSize: '12px',
        color: isDark ? '#4b5563' : '#9ca3af',
        fontFamily: "'DM Sans', sans-serif",
      }}>
        <span>© 2026 EstateCore CRM. Smart CRM that connects customers, data, and sales in one safe place.</span>
      </footer>

    </div>
  );
};
